import React from 'react';
import MainLayout from '../../components/MainLayout';
import TabMenu from '../../components/TabMenu';
import CompanyManagement from './CompanyManagement';
import DataVerification from './DataVerification';
import { useTranslation } from '../../context/LanguageContext';
import './AdminPage.css';

function AdminPage() {
  const { t } = useTranslation();

  const tabs = [
    {
      id: 'company',
      label: t('pages.admin.index.tab.company'),
      icon: 'business',
      content: <CompanyManagement />
    },
    {
      id: 'data',
      label: t('pages.admin.index.tab.data'),
      icon: 'analytics',
      content: <DataVerification />
    }
  ];

  const handleTabChange = (tabId) => {
    // 탭 변경 시 필요한 처리
  };

  return (
    <MainLayout>
      <div className="admin-page-container">
        <div className="admin-page-header">
          <div className="admin-page-header-left">
            <div className="admin-page-title">{t('pages.admin.index.title')}</div>
            <p className="admin-page-subtitle">{t('pages.admin.index.subtitle')}</p>
          </div>
        </div>

        <div className="admin-page-content">
          <TabMenu
            tabs={tabs}
            defaultTab="company"
            orientation="vertical"
            onTabChange={handleTabChange}
          />
        </div>
      </div>
    </MainLayout>
  );
}

export default AdminPage;
